import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import { ReactComponent as ArrowRightIcon } from "@Icons/16x16/arrow-right.svg";
import { Tile } from "@Types/pagify";
import { getLink } from "@Utils/pagify";
import "./style.scss";

export const SeoProductsItem: FunctionComponent<{ tile: Tile }> = ({ tile }) => {
  const intl = useIntl();
  const localeSlug = intl.locale;

  const title = !!tile.textBlock1 && tile.textBlock1[0].text;

  const description =
    !!tile.textBlock2 &&
    tile.textBlock2.map((textBlock) => {
      return textBlock.navigationLink?.link ? (
        <a
          className="SeoProductsItem-description-link"
          key={textBlock.text}
          href={getLink(textBlock.navigationLink, localeSlug)}
        >
          {textBlock.text}
        </a>
      ) : (
        <span className="SeoProductsItem-description-text" key={textBlock.text}>
          {textBlock.text}
        </span>
      );
    });

  const tileImage = tile.images.length > 0 && tile.images[0].desktop;

  return (
    <div className="SeoProductsItem">
      {tileImage && (
        <a className="SeoProductsItem-image" href={getLink(tile.navigationLink, localeSlug)}>
          <img
            alt={`${title ? title : ""} Cheerz`}
            src={tileImage["1x"]}
            srcSet={`${tileImage["1x"]} 1x, ${tileImage["2x"]} 2x`}
          />
        </a>
      )}
      <div className="SeoProductsItem-content">
        <h2 className="SeoProductsItem-title">
          <a href={getLink(tile.navigationLink, localeSlug)}>{title}</a>
        </h2>
        <div className="SeoProductsItem-description">{description}</div>
        {!!tile.cta && (
          <ButtonSmily
            href={getLink(tile.cta.navigationLink, localeSlug)}
            icon={<ArrowRightIcon />}
            iconPosition="right"
            type="tertiary"
            size="xs"
          >
            {tile.cta.text}
          </ButtonSmily>
        )}
      </div>
    </div>
  );
};
